import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TeaserBoxesIconConverter extends CmsConverterService<TeaserBoxesIconData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      headline: formData.st_headline ?? defaultTextInput,
      items: formData.st_teaser_boxes ?? defaultFSCatalog,
      zoomOut: formData.st_zoom_out?.value || false,
      promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? false
    }
  }
}

export const TEASER_BOXES_ICON_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxesIconData>>('TeaserBoxesIconConverter')

export interface TeaserBoxesIconData extends ConvertedComponentData {
  items: FsCatalog;
  backgroundColor: string;
  headline: TextInput;
  zoomOut: boolean;
  promotionTracking: boolean;
}
